// Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, take } from 'rxjs';
import { UserActionsService } from '../../store/actions';
import { AuthenticationCoreService } from './authentication-core.service';
import { TokenService } from './token.service';
import { UserRoles } from '../../shared/models/user.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(
    private authenticationCoreService: AuthenticationCoreService,
    private tokenService: TokenService,
    private userActionsService: UserActionsService,
    private router: Router,
    private store: Store<AppState>
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
    if (this.tokenService.getAccessTokenFromLocalStorage()) {
      const userRole = this.tokenService.getRolesFromJwtInLocalStorage();
      this.userActionsService.updateUserRoles(this.tokenService.getRolesFromJwtInLocalStorage());
      if (userRole.includes(UserRoles.Administrators)) {
        return true;
      } else {
        const IsAcceptTermsAndConditions = this.tokenService.getIsAcceptTermsAndConditionsFromJwt();
        let IsAcceptTermsAndConditionsFromStore = false;
        this.store
          .select('user')
          .pipe(take(1))
          .subscribe(user => {
            IsAcceptTermsAndConditionsFromStore = !!user?.IsAcceptTermsAndConditions;
          });
        if (IsAcceptTermsAndConditions != null && (IsAcceptTermsAndConditions || IsAcceptTermsAndConditionsFromStore)) {
          return true;
        } else {
          // this.authenticationCoreService.logout();
          return this.router.createUrlTree(['/Terms-Of-Service']);
        }
      }
    } else {
      this.authenticationCoreService.logout();
      return false;
    }
  }
}
